<!-- 对账单核销 -->
<template>
  <div>
    <!-- 按钮列表 -->
    <butotn-plug
      :btndata="BTN_CONFIG"
      @btnEvent="callBack"
      @clearBtns="clearBtns"
      @moreParam="moreParam"
      @queryBtn_ok="queryBtn_ok"
      @moreHandle="topCommandBtns"
      ref="btnList"
    />
    <!-- 查询列表 -->
    <input-plug
      ref="queryForm"
      :form-config="baseConfig"
      :form-data="queryData"
      :More="isHaseMore"
      @changeCallback="rowCallback"
    >
      <template slot="time1">
        <multitime
          :timeType="timeType"
          :timeTypes="timeTypes"
          :startTime="startTime_a"
          :endTime="endTime_a"
          @timestatus="timestatus"
          @queryBtn_ok="queryBtn_time"
        />
      </template>
      <template slot="time2">
        <el-form-item
          label="对账月份:"
          class="queryItems months11"
        >
          <el-date-picker
            v-model="queryData.statementMoth"
            value-format="yyyy-MM"
            type="month"
            placeholder="请选择"
          ></el-date-picker>
        </el-form-item>
      </template>
    </input-plug>
    <!-- 表格 -->
    <table-plug
      :tableConfig="tableConfig"
      :defaulthead="myTableHeard"
      :totals="totalArr"
      ref="mytable"
      @rowCallback="rowCallback"
      @selectChange="handleSelectionChange"
      @jumpPage="goYdDetails"
    />
    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    />

    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    />
    <!-- 批量核销 -->
    <my-dialog
      :diaWidth="diaWidth"
      dialogTitle="批量核销"
      :isShowDialog="isShowDialog_3"
      @handleCloseDia="handleCloseDia(3)"
      @diaCancelBtn="diaCancelBtn(3)"
      @diaConfirmBtn="diaConfirmBtn(3)"
    >
      <dia-form
        :diaFormConfig="diaFormConfig3"
        :baseModel="baseModel3"
        ref="diaform3"
        :rules="formRules"
        :Reset="isShowDialog_3"
      >
        <template slot="phone">
          <uploadimgs
            @input="changeFileList"
            :fileNameLists="fileNameLists"
            :limit="6"
          />
        </template>
      </dia-form>
    </my-dialog>
    <!-- 核销 -->
    <my-dialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle(1)"
      :isShowDialog="isShowDialog_1"
      @handleCloseDia="handleCloseDia(1)"
      @diaCancelBtn="diaCancelBtn(1)"
      @diaConfirmBtn="diaConfirmBtn(1)"
    >
      <dia-form
        :diaFormConfig="diaFormConfig"
        :baseModel="baseModel"
        ref="diaform"
        :rules="formRules"
        :Reset="isShowDialog_1"
      >
        <template slot="phone">
          <uploadimgs
            @input="changeFileList"
            :fileNameLists="fileNameLists"
            :limit="6"
          />
        </template>
      </dia-form>
    </my-dialog>

    <!-- 核销记录 -->
    <my-dialog
      :diaWidth="diaWidth"
      :double="false"
      :dialogTitle="dialogTitle(2)"
      :isShowDialog="isShowDialog_2"
      @handleCloseDia="handleCloseDia(2)"
      @diaCancelBtn="diaCancelBtn(2)"
      @diaConfirmBtn="diaConfirmBtn(2)"
    >
      <record-table
        :tableConfig="writeoffTable"
        :tableHeads="W_tableHeads"
        @selectChange="w_selectChange"
        @rowCallback="w_rowMethods"
      />
      <el-dialog
        title="核销图片"
        append-to-body
        :visible.sync="dialogVisible"
      >
        <el-image
          v-for="(item, index) in srcList"
          :key="index"
          style="width: 100px; height: 100px"
          :src="item"
          :preview-src-list="srcList"
        />
      </el-dialog>
    </my-dialog>
    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 查询列表 -->
      <input-plug
        ref="queryForm"
        :form-config="baseConfig"
        :form-data="queryData"
        :More="true"
        @changeCallback="rowCallback"
      >
        <template slot="time1">
          <multitime
            :timeType="timeType"
            :timeTypes="timeTypes"
            :startTime="startTime_a"
            :endTime="endTime_a"
            @timestatus="timestatus"
            @queryBtn_ok="queryBtn_time"
          />
        </template>
      </input-plug>
    </exportCompoent>
  </div>
</template>
<script>
import { mixin_1 } from '@/assets/js/Mixins/mixin'
import sorttable from '@/components/sortTemplate.vue' //自定义排序表头
import ButotnPlug from '@/components/Modules/ButtonPlug.vue'
import InputPlug from '@/components/Modules/InputPlug.vue'
import multitime from '@/components/multiTime.vue'
import paging from '@/components/pagings.vue' //分页组件
import TablePlug from '@/components/Modules/TablePlug.vue'
import MyDialog from '@/components/Dialog.vue'
import DiaForm from '@/pages/VMS/VMSConpon/DiaForm.vue'
import uploadimgs from '@/components/upLoadImgs.vue'
import RecordTable from '@/pages/FinancialManagement/FinancialWriteOff/FMMOD/RecordTable.vue'
import exportjs from '@/assets/js/Mixins/export.js' //导出的公共js
export default {
  mixins: [mixin_1, exportjs],
  components: {
    ButotnPlug,
    InputPlug,
    multitime,
    TablePlug,
    paging,
    sorttable,
    MyDialog,
    DiaForm,
    uploadimgs,
    RecordTable,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: '',
        fileName: '对账单核销', //导出时默认文件名
        apiName: '/admin/v3/tms/finance/getStatementList', //导出的数据列表接口名(动态列表都是这个)
        EpType: 'bdd', //dd==等待下载完成,bdd==不等待完成
        apiType: 'GET', //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      // 按钮配置
      BTN_CONFIG: [
        {
          name: '新建',
          method: 'create_m',
          permissVal: 'admin:finance_all:createStatement',
        },

        {
          name: '客户对账',
          method: 'Reconciliationed',
          permissVal: 'admin:finance_all:customerStatement',
        },
        {
          name: '取消对账',
          method: 'Unreconciliation',
          permissVal: 'admin:finance_all:cancelCustomerStatement',
        },
        {
          name: '开票申请',
          method: 'Invoice',
          permissVal: 'admin:invoice:addInvoice',
        },
        {
          name: '批量核销',
          method: 'BatchVerification',
        },

        {
          type: true,
          name: '更多操作',
          options: [
            {
              handleName: 'dc',
              label: '导出',
            },
            {
              handleName: 'bgsz',
              label: '表格设置',
            },
            {
              handleName: 'dy',
              label: '打印',
            },
          ],
        },
      ],
      // 更多搜索
      isHaseMore: false,
      //  查询框
      baseConfig: [
        {
          type: 'timeSelect',
          slotName: 'time1',
        },
        {
          type: 'doubleSelect',
          label: '结算对象',
          selectItem: [
            {
              field: 'objectStatusConfDictId',
              placeholder: '请选择',
              setLabel: 'val',
              setValue: 'confDictId',
              selectChange: 'GetUserDownList',
              selectOptions: [],
            },
            {
              field: 'objectName',
              placeholder: '请选择',
              setLabel: 'name',
              setValue: 'name',
              allowCreate: false,
              selectOptions: [],
            },
          ],
        },
        {
          type: 'input',
          label: '对账单号',
          field: 'number',
          placeholder: '请输入',
        },
        {
          type: 'select',
          label: '对账单',
          field: 'hasCreateStatement',
          placeholder: '请选择',
          setLabel: 'name',
          setValue: 'value',
          selectOptions: [
            {
              name: '已生成',
              value: '1',
            },
            {
              name: '未生成',
              value: '0',
            },
          ],
        },
        {
          type: 'select',
          label: '核销状态',
          field: 'writeoffStatus',
          placeholder: '请选择',
          setLabel: 'showName',
          setValue: 'statusVal',
          selectOptions: [],
        },
        {
          type: 'timeSelect',
          slotName: 'time2',
        },
      ],

      queryData: {
        businessDeptId: null,
        number: null,
        objectName: null,
        objectStatusConfDictId: null,
        reconciliationDeptId: null,
        writeoffStatus: null,
        hasCreateStatement: '0',
        statementMoth: '',
      },
      //  时间类型
      timeTypes: [
        {
          value: '0',
          label: '创建日期',
        },
      ],
      timeType: '0', //  时间类型
      startTime_a: '',
      endTime_a: '',
      // 表格配置
      tableConfig: {
        tableHeigth: '75vh',
        tableData: [],
      },
      myTableHeard: [],
      tabelHeadeTitle: [
        {
          name: '操作',
          field: 'edit',
          width: 230,
          Buttons: [
            {
              method: 'modify_m',
              methodName: '修改',
              permissVal: 'admin:finance_all:updateStatement',
            },
            {
              method: 'delete',
              methodName: '删除',
              permissVal: 'aaaaa',
            },
            {
              methodName: '核销',
              method: 'writeoff',
              // 应收部分核销权限
              permissVal: 'admin:finance_all:financeInPartWriteOff',
            },
            {
              methodName: '核销记录',
              method: 'writeoffRecord',
              permissVal: 'admin:finance_all:getStatementWriteoffRecorList',
            },
          ],
        },
        {
          name: '对账单号',
          field: 'number',
          width: '120', // default：120
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计 default：false
          isSort: true, //表格设置里面是否可以排序 default：false
        },
        {
          name: '对账月份',
          field: 'statementMoth',
          width: '120', // default：120
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计 default：false
          isSort: true, //表格设置里面是否可以排序 default：false
        },
        {
          name: '应收合计',
          field: 'financeInAmount',
          sort: 4,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: '应付合计',
          field: 'financeOutAmount',
          sort: 5,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: '结算金额',
          field: 'settlementAmount',
          width: '120',
          sort: 5,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: '核准金额',
          field: 'approvalAmount',
          width: '120',
          sort: 6,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: '已开票金额',
          field: 'invoiceAmount',
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: '未开票金额',
          field: 'noInvoiceAmount',
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: '已核销金额',
          field: 'writeoffAmount',
          width: '120',
          sort: 18,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: '未核销金额',
          field: 'noWriteoffAmount',
          sort: 19,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: '结算对象类型',
          field: 'objectStatus',
          width: '140',
          sort: 1,
          isShow: true,
          isSort: true,
        },
        {
          name: '结算对象',
          field: 'objectName',
          sort: 1,
          isShow: true,
          isSort: true,
        },
        {
          name: '核销状态',
          field: 'writeoffStatusShow',
          sort: 2,
          isShow: true,
        },
        {
          name: '客户对账状态',
          field: 'customerReconciliationStatusShow',
          width: 140,
          sort: 2,
          isShow: true,
        },

        {
          name: '业务网点',
          field: 'businessDeptName',
          sort: 1,
          isShow: true,
        },
        {
          name: '对账网点',
          field: 'reconciliationDeptName',
          width: '120',
          sort: 1,
          isShow: true,
        },
        {
          name: '对账单备注',
          field: 'reconciliationRemark',
          width: '160',
          sort: 1,
          isShow: true,
        },

        {
          name: '创建人',
          field: 'createUserName',
          sort: 120,
          isShow: true,
        },

        {
          name: '最新核销人',
          field: 'writeoffUserName',
          sort: 6,
          isShow: true,
        },

        {
          name: '最新核销时间',
          field: 'writeoffTime',
          width: '140',
          sort: 1,
        },
        {
          name: '最新资金账号',
          field: 'zjAccount',
          width: '140',
          sort: 1,
        },
        {
          name: '最新核销备注',
          field: 'writeoffComment',
          width: '140',
          sort: 1,
          isShow: true,
        },
      ],
      pageGroupName: 'BillWriteoff',
      sortName: '对账单核销', //  排序名
      // 核销弹窗
      diaWidth: '60%',
      isShowDialog_1: false,
      isShowDialog_3: false,
      diaFormConfig: [
        {
          gutter: 16,
          formItem: [
            {
              span: 8,
              title: '总金额',
              itemType: 'input',
              field: 'allmoneys',
              labelwidth: 120,
              placeholder: '请输入',
              disabled: true,
            },
            {
              span: 8,
              title: '本次核销金额',
              itemType: 'input',
              labelwidth: 120,
              field: 'writeoffAmount',
              placeholder: '请输入',
            },
            {
              span: 8,
              title: '剩余核销金额',
              itemType: 'input',
              field: 'surplusmoney',
              placeholder: '请输入',
              disabled: true,
            },
          ],
        },
        {
          gutter: 16,
          formItem: [
            {
              span: 8,
              title: '核销资金账号',
              itemType: 'select',
              field: 'accountId',
              placeholder: '请选择',
              labelwidth: 120,
              setLabel: 'account',
              setValue: 'assetaccountId',
              options: [],
            },
            {
              span: 8,
              title: '核销时间',
              itemType: 'datetime',
              field: 'writeOffTime',
              placeholder: '选择时间',
            },
          ],
        },
        {
          gutter: 16,
          formItem: [
            {
              span: 24,
              title: '备注',
              itemType: 'textarea',
              field: 'writeoffComment',
              placeholder: '请选择',
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 24,
              title: '图片',
              itemType: 'upload',
              slot: 'phone',
            },
          ],
        },
      ],
      baseModel: {
        allmoneys: 0,
        surplusmoney: 0,
      },
      diaFormConfig3: [
        {
          gutter: 24,
          formItem: [
            {
              span: 12,
              title: '收款金额',
              itemType: 'input',
              field: 'allmoneys1',
              labelwidth: 120,
              placeholder: '请输入',
              disabled: true,
            },
            {
              span: 12,
              title: '付款金额',
              itemType: 'input',
              field: 'allmoneys2',
              labelwidth: 120,
              placeholder: '请输入',
              disabled: true,
            },
          ],
        },
        {
          gutter: 24,
          formItem: [
            {
              span: 12,
              title: '核销资金账号',
              itemType: 'select',
              field: 'accountId',
              placeholder: '请选择',
              labelwidth: 120,
              setLabel: 'account',
              setValue: 'assetaccountId',
              options: [],
            },
            {
              span: 12,
              title: '核销时间',
              itemType: 'datetime',
              field: 'writeOffTime',
              placeholder: '选择时间',
            },
          ],
        },
        {
          gutter: 16,
          formItem: [
            {
              span: 24,
              title: '备注',
              itemType: 'textarea',
              field: 'writeoffComment',
              placeholder: '请选择',
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 24,
              title: '图片',
              itemType: 'upload',
              slot: 'phone',
            },
          ],
        },
      ],
      baseModel3: {
        accountId: '',
        writeOffTime: '',
        writeoffComment: '',
        writeOffPics: '',
        statementIds: '',
        allmoneys: 0,
      },
      defaultBaseModel: {
        accountId: null,
        statementId: null,
        writeOffPics: null,
        writeOffTime: null,
        writeoffAmount: null,
        writeoffComment: null,
      },
      formRules: {
        writeOffTime: [
          { required: true, message: '请选择时间', trigger: 'change' },
        ],
        writeoffAmount: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        accountId: [{ required: true, message: '请选择', trigger: 'change' }],
      },
      fileNameLists: [],
      // 核销记录
      isShowDialog_2: false,
      dialogVisible: false,
      srcList: [],
      // 表格配置
      writeoffTable: {
        maxHeight: '75vh',
        tableData: [],
      },
      W_tableHeads: [
        {
          name: '操作',
          field: 'edit',
          method: 'ReWriteoff',
          methodName: '反核销',
        },
        {
          name: '核销金额',
          field: 'writeoffedAmount',
        },
        {
          name: '操作类型',
          field: 'operationTypeShow',
        },
        {
          name: '结算金额',
          field: 'settlementAmount',
        },
        {
          name: '剩余待核销金额',
          field: 'unwriteoffAmount',
          width: '140',
        },
        {
          name: '核销资金账号',
          field: 'zjAccount',
          width: '140',
        },
        {
          name: '核销人',
          field: 'writeoffUserName',
        },
        {
          name: '核销时间',
          field: 'writeoffTime',
        },
        {
          name: '核销备注',
          field: 'writeoffComment',
        },
        {
          name: '图片',
          width: '120',
          hasButton: true,
          disabled: false,
          method: 'viewImages',
          methodName: '点击查看',
        },
      ],
    }
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1
      }
      this.tabelHeadeTitle = arr
    }
  },
  created() {
    this.startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum) //开始时间;
    this.endTime_a = this.$TOOLS.getCurrentDate() //今天的时间;
    this.GetData()
    this.getAssetaccountList()
    this.getConfDictValDownList('object_status')
    // 获取应收核销状态
    this.$TOOLS
      .getStatusValList('finance_in_record_v1.writeoff_status')
      .then((res) => {
        this.baseConfig[4].selectOptions = res
      })
  },
  methods: {
    // 获取对账单列表
    GetData() {
      this.queryData.pageStart = this.pageStart
      this.queryData.pageTotal = this.pageTotal
      this.queryData.startCreateTime = this.startTime_a
        ? this.startTime_a + ' 00:00:00'
        : ''
      this.queryData.endCreateTime = this.endTime_a
        ? this.endTime_a + ' 23:59:59'
        : ''
      this.$API.StatementList(this.queryData).then((res) => {
        if (res.data.status === 'success') {
          this.className = res.data.result.className || ''
          this.tableConfig.tableData = res.data.result.data || []
          this.pageCount = res.data.result.pageCount || 0
          this.$nextTick(() => {
            this.fetTableHeight()
          })
        } else {
          this.$message.error(`${res.data.message}---对账单列表`)
        }
      })
    },

    // // 获取核销记录
    getRecord(id) {
      this.$API.StatementWriteoffRecorList({ statementId: id }).then((res) => {
        if (res.data.status === 'success') {
          this.writeoffTable.tableData = res.data.result || []
        } else {
          console.log(res.data.message)
        }
      })
    },

    // 获取已启用的资金账号列表
    getAssetaccountList() {
      this.$API.assetaccountList({ isShow: '1' }).then((res) => {
        if (res.data.status === 'success') {
          let result = res.data.result?.data || []
          this.diaFormConfig[1].formItem[0].options = result
          this.diaFormConfig3[1].formItem[0].options = result
        } else {
          console.log(res.data.message)
        }
      })
    },
    // 获取结算对象类型
    getConfDictValDownList(PARAM) {
      this.$API.wtl_getConfDictValDownList({ dictType: PARAM }).then((res) => {
        if (res.data.status === 'success') {
          this.baseConfig[1].selectItem[0].selectOptions = res.data.result || []
        } else {
          console.log(res.data.message)
        }
      })
    },
    // 根据结算对象类型获取结算对象
    GetUserDownList(e) {
      let arr = this.baseConfig[1].selectItem[0].selectOptions
      let num = arr.findIndex((element) => element.confDictId == e)
      let objectKey = arr[num].key
      // 结算对象为其他的时候自动输入
      if (objectKey === 'other') {
        this.queryData.objectName = ''
        this.baseConfig[1].selectItem[1].allowCreate = true
        this.baseConfig[1].selectItem[1].placeholder = '请输入'
        this.baseConfig[1].selectItem[1].selectOptions = []
      } else {
        this.baseConfig[1].selectItem[1].allowCreate = false
        this.baseConfig[1].selectItem[1].placeholder = '请选择'
        this.$API
          .wtl_getObjectUserDownList({
            key: objectKey,
            pageStart: 1,
            pageTotal: 1000,
          })
          .then((res) => {
            if (res.data.status === 'success') {
              let result = res.data.result?.data || []
              this.queryData.objectName = ''
              this.baseConfig[1].selectItem[1].selectOptions = result
            }
          })
      }
    },
    // 财务返核销
    FinanceInUnWriteOff(id) {
      this.$API.financeInUnWriteOff({ recordId: id }).then((res) => {
        if (res.data.status === 'success') {
          this.getRecord(this.selectTableData[0].statementId)
          this.$message.success(res.data.message)
        } else {
          console.log(res.data.message)
        }
      })
    },
    // 表格内按钮的回调事件
    rowCallback(data, name) {
      this[name](data)
    },
    // 新建
    create_m() {
      this.$router.push({
        path: '/FM/ClearingBill/1',
        query: {
          add: 'create',
        },
      })
    },
    // 修改
    modify_m(data) {
      if (data) this.selectTableData = [data]
      if (this.selectTableData.length !== 1) {
        this.$message.error('请选择一条数据进行操作')
        return false
      } else {
        this.$router.push({
          path: '/FM/ClearingBill/1',
          query: { statementNum: this.selectTableData[0].number },
        })
      }
    },

    // 客户已对账
    Reconciliationed(data) {
      if (data) this.selectTableData = [data]
      if (this.selectTableData.length < 1) {
        this.$message.error('请至少选择一条数据进行操作')
        return false
      } else {
        this.$confirm('确认要把所选数据标记为客户已对账?', '提示:')
          .then((res) => {
            let updateReq = {
              statementIds: new Array(),
            }
            this.selectTableData.map(function (val, i) {
              updateReq.statementIds.push(val.statementId)
            })
            this.$API.customerStatement(updateReq).then((r) => {
              if (r.data.status === 'success') {
                this.GetData()
                this.$message.success(r.data.message)
              }
            })
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0
          })
      }
    },
    // 取消对账
    Unreconciliation(data) {
      if (data) this.selectTableData = [data]
      if (this.selectTableData.length < 1) {
        this.$message.error('请至少选择一条数据进行操作')
        return false
      } else {
        this.$confirm('确认要把所选数据取消对账?', '提示:')
          .then((res) => {
            let updateReq = {
              statementIds: new Array(),
            }
            this.selectTableData.map(function (val, i) {
              updateReq.statementIds.push(val.statementId)
            })
            this.$API.cancelCustomerStatement(updateReq).then((r) => {
              if (r.data.status === 'success') {
                this.GetData()
                this.$message.success(r.data.message)
              }
            })
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0
          })
      }
    },

    BatchVerification(data) {
      if (data) this.selectTableData = [data]
      if (this.selectTableData.length < 1) {
        this.$message.error('请至少选择一条数据进行操作')
        return false
      } else {
        let result1 = 0
        let result2 = 0
        this.selectTableData.forEach((item) => {
          if (Number(item.approvalAmount) > 0) {
            result1 += Number(item.approvalAmount)
          } else {
            result2 += Number(item.approvalAmount)
          }
        })
        this.fileNameLists = []
        this.baseModel3.allmoneys1 = result1
        this.baseModel3.allmoneys2 = Math.abs(result2)
        this.isShowDialog_3 = true
      }
    },
    // 开票申请
    Invoice(data) {
      if (data) this.selectTableData = [data]
      if (this.selectTableData.length == 1) {
        this.$router.push({
          path: '/FM/InvoicesControlRX/InvoicesAddRX',
          // path: "/FM/InvoicesAdd/1",
          query: {
            keyType: 1,
            number: this.selectTableData[0].number,
          },
        })
      } else {
        this.$message.error('请选择一条数据进行操作')
        return false
      }
    },
    // 核销
    writeoff(data) {
      if (data) this.selectTableData = [data]
      if (this.selectTableData.length !== 1) {
        this.$message.error('请选择一条数据进行操作')
        return false
      } else {
        this.baseModel.financeIds = []
        this.baseModel.allmoneys = this.selectTableData[0].approvalAmount
        this.baseModel.surplusmoney = this.selectTableData[0].noWriteoffAmount
        this.baseModel.statementId = this.selectTableData[0].statementId
        this.isShowDialog_1 = true
      }
    },
    // 删除
    delete(data) {
      if (data) this.selectTableData = [data]
      if (this.selectTableData.length < 1) {
        this.$message.error('请至少选择一条数据进行操作')
        return false
      } else {
        this.$confirm('确定要删除所选数据吗?', '提示:')
          .then((res) => {
            let delReq = {
              statementIds: new Array(),
            }
            this.selectTableData.map(function (val, i) {
              delReq.statementIds.push(val.statementId)
            })
            this.$API.delStatement(delReq).then((res) => {
              if (res.data.status === 'success') {
                try {
                  let num = 0
                  let arr = this.tableConfig.tableData
                  if (delReq.statementIds.length > 2) {
                    delReq.statementIds.map(function (v, i) {
                      num = arr.findIndex((element) => element.statementId == v)
                      arr.splice(num, 1)
                    })
                  } else {
                    num = arr.findIndex(
                      (element) => element.statementId == delReq.statementIds[0]
                    )
                    arr.splice(num, 1)
                  }
                } catch {
                  this.GetData()
                }
                this.$message.success(res.data.message)
              }
            })
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0
          })
      }
    },
    // 整单核销选择图片
    changeFileList(array) {
      this.fileNameLists = array
    },
    // 核销记录
    writeoffRecord(data) {
      if (data) this.selectTableData = [data]
      if (this.selectTableData.length !== 1) {
        this.$message.error('请选择一条数据进行操作')
        return false
      } else {
        this.getRecord(this.selectTableData[0].statementId)
        this.isShowDialog_2 = true
      }
    },
    viewImages(val) {
      let imgs = val?.fileIds || []
      this.$API.getFileUrlMore({ fileNames: imgs }).then((res) => {
        if (res.data.status === 'success') {
          let result = res.data.result
          this.srcList = []
          for (let i in result) {
            this.srcList.push(result[i].url)
          }
          this.dialogVisible = true
        } else {
          console.log(res.data.message)
        }
      })
    },
    //顶部跟多按钮的操作
    topCommandBtns(a) {
      if (a === 'bgsz') {
        // 设置模板按钮
        // this.myModel();
        this.$TOOLS.myModel(this)
      }
      if (a === 'dyyd') {
        // 打印运单
      }
      if (a === 'dybq') {
        // 打印标签
      }
      if (a === 'dr') {
        // 导入
      }
      if (a === 'dc') {
        // // 导出
        // // this.exportBtn();
        // this.$COMAPI.exportBtn({
        //   pageGroupName: this.pageGroupName, //页面标识
        //   myTableHeard: this.myTableHeard, //表头数组
        //   className: this.className, //列表标识
        //   tableData: this.tableConfig.tableData, //数据源
        //   sheetName: "表名(暂无效)", //表名
        // });
        this.isShowDialog_dc = true
      }
    },
    // 当前弹窗的标题赋值
    dialogTitle(e) {
      return e === 1
        ? '核销'
        : e === 2
        ? '部分核销'
        : e === 3
        ? '核销记录'
        : '编辑'
    },
    // 更多搜索
    moreParam(e) {
      this.isHaseMore = e
      this.$nextTick(() => {
        this.fetTableHeight()
      })
    },
    // 查询事件
    queryBtn_ok() {
      this.GetData()
    },
    // 清空查询
    clearBtns() {
      this.$refs['queryForm'].$refs.forms.resetFields()
      this.GetData()
    },
    // // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e
    },
    // 跳转运单详情
    goYdDetails(a) {
      this.$message.success('你点我干嘛')
    },

    // 整单核销
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia(e) {
      this.diaCancelBtn(e)
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn(e) {
      if (e === 1) {
        this.baseModel = {
          allmoneys: 0,
          surplusmoney: 0,
        }
        this.isShowDialog_1 = false
      }
      if (e === 2) {
        this.writeoffTable.tableData = []
        this.isShowDialog_2 = false
      }
      if (e === 3) {
        this.baseModel3 = {
          accountId: '',
          writeOffTime: '',
          writeoffComment: '',
          writeOffPics: '',
          statementIds: '',
        }
        this.isShowDialog_3 = false
      }
    },
    //  弹窗确认保存事件
    diaConfirmBtn(e) {
      if (e == 1) this.BFcomfirm()
      if (e === 2) this.diaCancelBtn(e)
      if (e === 3) this.BFcomfirm3()
    },
    BFcomfirm3() {
      this.$refs['diaform3'].$refs.addForm.validate((valid) => {
        if (valid) {
          // 正常提交
          this.baseModel3.statementIds = this.selectTableData.map((n) => {
            return n.statementId
          })
          this.baseModel3.writeOffPics = []
          for (let i in this.fileNameLists) {
            this.baseModel3.writeOffPics.push(this.fileNameLists[i].name)
          }
          this.$API.statementBatchWriteOff(this.baseModel3).then((res) => {
            if (res.data.status === 'success') {
              this.$message.success(res.data.message)
              this.isShowDialog_3 = false
              this.GetData()
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    BFcomfirm() {
      this.$refs['diaform'].$refs.addForm.validate((valid) => {
        if (valid) {
          // 正常提交
          let param = {}
          for (let key in this.defaultBaseModel) {
            if (this.baseModel[key] || this.baseModel[key] == 0) {
              eval('param.' + key + "='" + this.baseModel[key] + "'")
            } else {
              eval('param.' + key + "=''")
            }
          }
          param.writeOffPics = []
          for (let i in this.fileNameLists) {
            param.writeOffPics.push(this.fileNameLists[i].name)
          }
          this.$API.statementWriteOff(param).then((res) => {
            if (res.data.status === 'success') {
              this.$message.success(res.data.message)
              this.isShowDialog_1 = false
              this.GetData()
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 核销记录
    w_selectChange(e) {
      console.log(e)
    },
    w_rowMethods(e, t) {
      this[t](e)
    },
    ReWriteoff(e) {
      console.log(e)
      this.$confirm('确认要把所选数据反核销吗?', '提示:')
        .then((res) => {
          this.FinanceInUnWriteOff(e.recordId)
        })
        .catch((err) => {})
    },
  },
}
</script>
<style scoped lang="less">
.months11 {
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    // width: 210px !important;
    min-width: auto;
    width: 80px;
  }
  /deep/.el-input__prefix {
    left: -20px;
  }
}
</style>
